import bitcoin from "./Assets/bitcoin.png";
import burger from "./Assets/burger.png";
import crown from "./Assets/crown.png";
import diamond from "./Assets/diamond.png";
import fruit from "./Assets/fruit.png";
import penguin from "./Assets/penguin.png";
import pizza from "./Assets/pizza.png";
import sword from "./Assets/sword.png";

export const cardImages = [
    bitcoin,
    burger,
    crown,
    diamond,
    fruit,
    penguin,
    pizza,
    sword
]